import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStepBack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconStepBack"><Path fillRule="evenodd" clipRule="evenodd" d="M8.41436 3.00015L6.41436 5.00015H13.5002C17.6423 5.00015 21.0002 8.35802 21.0002 12.5002C21.0002 16.6423 17.6423 20.0002 13.5002 20.0002H5.00015V18.0002H13.5002C16.5377 18.0002 19.0002 15.5377 19.0002 12.5002C19.0002 9.46258 16.5377 7.00015 13.5002 7.00015H6.41436L8.41436 9.00015L7.00015 10.4144L2.58594 6.00015L7.00015 1.58594L8.41436 3.00015Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStepBack;
